import * as $ from 'jquery';

class ToggleActive {

  constructor(obj) {
    this.currElm = obj.currElm;
    this.setElms = obj.setElms || [];
    this.evts = obj.evts;
    this.func = obj.func || null;
    this.toggleOrAdd = obj.addOrRemove + 'Class';
    this.class = obj.classname || 'active';
    this.preventDef = obj.preventDef;
    this.events();
  }

  events() {
    this.evts.map(event => {
      $(this.currElm).on(event, this.toggleClassActive.bind(this))
    });
  }

  toggleClassActive(e) {
    const currElm = e.currentTarget;
    const func = () => {
      if (!this.setElms.length) {
        $(currElm)[this.toggleOrAdd](this.class);
      } else {
        this.setElms.map(elm => {
          $(currElm).closest(elm)[this.toggleOrAdd](this.class);
        });
      }
    }

    if (this.func) {
      this.func(e, func);
    } else {
      func();
    }
    e.stopPropagation();
    if (this.preventDef) {
      e.preventDefault();
    }
  }

}

export default ToggleActive;


// WEBPACK FOOTER //
// ./resources/assets/scripts/modules/toggle-active.js